import React from 'react';
import PropTypes from 'prop-types';

import TabView, { Tab } from '../../../components/TabView';
import Strings from '../../../Strings';
import AccessSimulator from './AccessSimulator/AccessSimulator';
import AccessObligations from './AccessObligations/AccessObligations';
import AthenaSimulator from './AthenaSimulator/AthenaSimulator';
import NppesSimulator from './NppesSimulator/NppesSimulator';

// Superuser-only "Dev" section,
// modelled on SystemConfiguration: one page component rendered by one route per
// tab, with the active tab passed down.
export const DevTabs = {
  AccessSimulator: {
    name: Strings.accessSimulatorTab,
    path: '/dev/access-simulator',
  },
  AccessObligations: {
    name: Strings.accessObligationsTab,
    path: '/dev/access-obligations',
  },
  AthenaSimulator: {
    name: Strings.athenaSimulatorTab,
    path: '/dev/athena-simulator',
  },
  NppesSimulator: {
    name: Strings.nppesSimulatorTab,
    path: '/dev/nppes-simulator',
  },
};

function Dev({ activeTab }) {
  return (
    <TabView routeMode activeTab={activeTab}>
      <Tab
        name={DevTabs.AccessSimulator.name}
        path={DevTabs.AccessSimulator.path}
        key={DevTabs.AccessSimulator.name}
      >
        <AccessSimulator />
      </Tab>
      <Tab
        name={DevTabs.AccessObligations.name}
        path={DevTabs.AccessObligations.path}
        key={DevTabs.AccessObligations.name}
      >
        <AccessObligations />
      </Tab>
      <Tab
        name={DevTabs.AthenaSimulator.name}
        path={DevTabs.AthenaSimulator.path}
        key={DevTabs.AthenaSimulator.name}
      >
        <AthenaSimulator />
      </Tab>
      <Tab
        name={DevTabs.NppesSimulator.name}
        path={DevTabs.NppesSimulator.path}
        key={DevTabs.NppesSimulator.name}
      >
        <NppesSimulator />
      </Tab>
    </TabView>
  );
}

Dev.propTypes = {
  activeTab: PropTypes.string,
};

export default Dev;
